export default __webpack_public_path__ + "static/media/app-icon.62126eb8.jpg";